import { View } from 'react-native';
import { type SpacingScale, spacing } from '../../theme/spacing';

interface SpacerProps {
  size?: SpacingScale;
  flex?: number;
  horizontal?: boolean;
}

export const Spacer = ({ size = 'md', flex, horizontal }: SpacerProps) => {
  if (flex !== undefined) {
    return <View style={{ flex }} />;
  }

  const dimension = spacing[size];

  return (
    <View
      style={{
        width: horizontal ? dimension : undefined,
        height: horizontal ? undefined : dimension,
      }}
    />
  );
};
